import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

export function setCardListContent(store) {
  return {};
}

export function setErrorCodeVerbiage(store) {
  return {
    errorCodeContent: store.verbiageContainer,
    errorScenarios: store.errorScenarios
  };
}

export function setOccupationContent(store) {
  return {
    occupationOptionContent: store.name_value_pair,
  };
}
export function setIncomeSurrogateContent(store) {
  return {
    surrogateOptionContent: store.name_value_pair,
  };
}
export function setAppContent(store) {
  return {
    firstNameContent: store.personalDetails.name_container.firstName,
    middleNameContent: store.personalDetails.name_container.middleName,
    lastNameContent: store.personalDetails.name_container.lastName,
    mobileNoContent: store.personalDetails.mobile_container,
    motherNameContent: store.personalDetails.motherName_container,
    emailContent: store.personalDetails.email_container,
    otpContent: store.personalDetails.otp_container,
    cityContent: store.personalDetails.city_container,
    panContent: store.personalDetails.pan_container,
    dobContent: store.personalDetails.dob_container,
    personalDetailsContent: store.personalDetails,
    occupationContent: store.professionalDetails.occupation_container,

    headingContent: store.professionalDetails.heading,
    designationContent: store.professionalDetails.designation_container,
    companyContent: store.professionalDetails.company_container,
    professionalDetailsContent: store.professionalDetails,
    workAddressContent: store.professionalDetails.workAddress_container,
    leftSectionContent: store.leftSection_container,
    happyToHelpContent: store.happy_to_help,
    finalECardLookContent: store.final_eCard_look,
    cardResumeContent: store.card_resume,
    cardTilePageContent: store.card_tile_page,
    savedDetailsPopupContent: store.saved_details_popup,
    kycDetailsContent: store.kycDetails,
    manualAddressContent: store.kycDetails.manual_address_entry_container,
    digilockerContent: store.kycDetails.digilocker_container,
    genderKYCContent: store.kycDetails.gender_kyc_container,
    aadhaarOtpContent: store.kycDetails.digilocker_container.aadhaar_otp_container,
    photoKYCContent: store.kycDetails.photo_kyc,
    multicardContent: store.multicard_eligibility,
    virtualCardContent: store.kycDetails.card_eligibility_container,
    closeJourneyContent: store.close_journey_popup,
    changeCardContent: store.leftSection_container.changeCard_container.change_card_page,
    landingPageContent: store.landing_page,
    pennyDropContent: store.pennydrop_container,
    globalConfigContent: store.globalconfig_container,
    footerContainer: store.footer_container,
    panUploadContent: store.pan_upload,
    helpCenterContent: store.help_contents,
    mobileOptionsContent: store.kycDetails.photo_kyc.mobile_options,
    customerEnhancementContent: store.download_app,
    applicationSubmissionContent: store.application_submission,
    cardActivatedContent: store.card_activated,
    setPreferencesContent: store.set_preferences,
    availCardContent: store.avail_card,
    technicalErrorContent: store.technical_error,
    timeoutErrorContent: store.timeout_error,
    errorMaintainenceContent: store.error,
    shortleadcontainerContent: store.shortleadcontainer,
    telcoIntegrationContent:store.telco_integration,
    incomeSurrogateContent: store.income_surrogate,
    employeeIdContent : store.employeeDetails,
  };
}
export function useOccupationContent(prop) {
  const apiAppContent = useSelector(
    (state) => state.AppState.occupationDetails
  );

  const [pageData, setPageData] = useState(setOccupationContent(apiAppContent));

  useEffect(() => {
    setPageData(setOccupationContent(apiAppContent));
  }, [apiAppContent]);

  return pageData;
}

export function useCardListContent(prop) {
  const cardListContent = useSelector(
    (state) => state.AppState.cardNameContent
  );

  const [pageData, setPageData] = useState(setCardListContent(cardListContent));

  useEffect(() => {
    setPageData(setCardListContent(cardListContent));
  }, [cardListContent]);

  return pageData;
}

export function useAppContent(prop) {
  const apiAppContent = useSelector((state) => state.AppState.appContent);

  const [pageData, setPageData] = useState(setAppContent(apiAppContent));

  useEffect(() => {
    setPageData(setAppContent(apiAppContent));
  }, [apiAppContent]);

  return pageData;
}

export function useErrorCodeVerbiage(prop) {
  const apiErrorContent = useSelector((state) => state.AppState.errorContent);
  const [pageData, setPageData] = useState(
    setErrorCodeVerbiage(apiErrorContent)
  );

  useEffect(() => {
    setPageData(setErrorCodeVerbiage(apiErrorContent));
  }, [apiErrorContent]);

  return pageData;
}

// Hook
export function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
